import { render, staticRenderFns } from "./my_advice.vue?vue&type=template&id=81a6c540&scoped=true&"
import script from "./my_advice.vue?vue&type=script&lang=js&"
export * from "./my_advice.vue?vue&type=script&lang=js&"
import style0 from "./my_advice.vue?vue&type=style&index=0&id=81a6c540&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "81a6c540",
  null
  
)

export default component.exports